import { GET_NEWS } from "./constantes"

export const getNews = (payload) => {
    return {
        type: GET_NEWS,
        payload
    }
}